// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"301ef4d2","688":"bc9a058e"}[chunkId] + ".chunk.css";
};